import { AnimatePresence, motion } from "motion/react";
import type { GameKind } from "@minigames/shared";
import { RULES } from "../lib/rules.js";
import { haptic } from "../lib/telegram.js";

const TITLE: Record<GameKind, string> = {
  chess: "Шахматы",
  durak: "Дурак",
  checkers: "Шашки",
  reversi: "Реверси",
  gomoku: "Пять в ряд",
  seabattle: "Морской бой",
};

export function RulesSheet({
  game,
  open,
  onClose,
}: {
  game: GameKind;
  open: boolean;
  onClose(): void;
}) {
  const rules = RULES[game];

  return (
    <AnimatePresence>
      {open && (
        <>
          <motion.div
            className="backdrop"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
          />
          <motion.div
            className="rules-sheet"
            initial={{ y: "100%" }}
            animate={{ y: 0 }}
            exit={{ y: "100%" }}
            transition={{ type: "spring", stiffness: 360, damping: 34 }}
          >
            <div className="rules-grip" />
            <div className="rules-scroll">
              <div style={{ fontSize: 20, fontWeight: 700, marginBottom: 2 }}>{TITLE[game]}</div>
              <div className="muted small" style={{ marginBottom: 16 }}>
                {rules.goal}
              </div>

              <div className="rules-label">Как ходить</div>
              <ol className="rules-list">
                {rules.how.map((step) => (
                  <li key={step}>{step}</li>
                ))}
              </ol>

              <div className="rules-label">Важно знать</div>
              <ul className="rules-list rules-dots">
                {rules.notes.map((note) => (
                  <li key={note}>{note}</li>
                ))}
              </ul>
            </div>

            <button
              className="btn btn-primary"
              onClick={() => {
                haptic.tap();
                onClose();
              }}
            >
              Понятно
            </button>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}

/** Однострочная подсказка поверх доски при первом заходе в игру. */
export function FirstHint({ game, onDismiss }: { game: GameKind; onDismiss(): void }) {
  return (
    <motion.button
      className="first-hint"
      initial={{ opacity: 0, y: -8 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -8 }}
      onClick={() => {
        haptic.tap();
        onDismiss();
      }}
    >
      <span>💡 {RULES[game].hint}</span>
      <span className="first-hint-close">✕</span>
    </motion.button>
  );
}
